<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：会员-积分管理
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="积分明细" name="first"></el-tab-pane>
      <el-tab-pane label="" name="exchange">
          <span slot="label">积分领取申请 <span class="red">({{waitSettled.points_log_count>99?'99+':waitSettled.points_log_count}})</span> </span>
      </el-tab-pane>
      <!-- <el-tab-pane label="积分领取申请" name="exchange"> <span class="red">({{waitSettled.points_log_count>99?'99+':waitSettled.points_log_count}})</span> </el-tab-pane> -->
      <el-tab-pane label="积分设置" name="second"></el-tab-pane>
      
      <el-tab-pane label="邀请送积分" name="DirectRecommend" v-if="show_DirectRecommend == true"></el-tab-pane>
    </el-tabs>

    <!--积分明细-->
    <Log v-if="activeName == 'first'"></Log>
    <Exchange v-if="activeName == 'exchange'"></Exchange>
    <!--积分设置-->
    <Setting v-if="activeName == 'second'"></Setting>
    <!--拉新设置-->
    <DirectRecommend v-if="activeName == 'DirectRecommend' && show_DirectRecommend == true"></DirectRecommend>

  </div>
</template>
<script>
import Setting from './part/Setting';
import Log from './part/Log';
import Exchange from './part/Exchange';
import DirectRecommend from './part/DirectRecommend';
import DataApi from '@/api/data.js';
export default {
  components: {
    Setting,
    Log,
    Exchange,
    DirectRecommend
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'first',
      show_DirectRecommend: false,
      waitSettled:{
          order_count:0,
          order_refund_count:0,
          diary_count:0,
          diary_comment_count:0,
          activity_count:0,
          activity_log_count:0,
          points_log_count:0,
      }
    };
  },
  created() {
    /*权限检测*/
    if(this.$filter.isAuth('/user/points/part/DirectRecommend'))  this.show_DirectRecommend = true;
    this.getData()
  },
  methods: {
    getData() {
          let self = this;
          DataApi.getWaitSettled({}, true)
              .then(res => {
              self.waitSettled = res.data.list;
          })
          .catch(error => {});
      },
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/points/index.vue